import { ref } from 'vue'
import { client } from '@/services/api'

// Portal-Administration auf dem VPS (Auftrag): EIN Docker-Image bedient
// sowohl den Mac (lokal, alle Features) als auch den VPS (Portal-only,
// MERIDIAN_DEPLOYMENT=portal in deploy/backend.env, siehe app.py) - keine
// separate Build-Variante. GET /health ist der einzige unauthentifizierte,
// öffentliche Endpoint, der das zur Laufzeit verrät (app.py: health()
// Response enthält "deployment": "local" | "portal"), deshalb hier statt
// über einen Build-Time-Env-Var geprüft.
//
// Modul-weiter Singleton-State (wie currentUser in services/auth.js) - jede
// Komponente, die diesen Composable nutzt, teilt sich dasselbe Ergebnis statt
// bei jedem Mount neu gegen /health zu fragen.
const deployment = ref(null) // null = noch nicht geladen, sonst 'local' | 'portal'
let loadPromise = null

async function loadDeploymentMode() {
  if (loadPromise) return loadPromise
  loadPromise = client.get('/health')
    .then((resp) => {
      deployment.value = resp.data?.deployment === 'portal' ? 'portal' : 'local'
    })
    .catch(() => {
      // /health selbst nicht erreichbar ist ein anderes, grösseres Problem
      // als Betriebsart-Erkennung - im Zweifel "local" annehmen (keine
      // Features verstecken, die vielleicht doch da sind), nicht "portal".
      deployment.value = 'local'
    })
  return loadPromise
}

export function useDeploymentMode() {
  if (deployment.value === null) loadDeploymentMode()
  return { deployment }
}

// For the router guard (router/index.js), which needs the resolved value
// BEFORE deciding on a navigation, not just the (possibly still-null)
// reactive ref a component would read on the next render.
export async function ensureDeploymentMode() {
  await loadDeploymentMode()
  return deployment.value
}
